import PhaseOfPlay from "@Enums/PhaseOfPlay";
import StorageKeys from "@Enums/StorageKeys";
import appStorage from "@Context/storage";

/**
 * Load selected phases of play from local storage
 * @returns Array of PhaseOfPlay or empty array if none found/invalid
 */
export const loadPhasesFromStorage = (): PhaseOfPlay[] => {
  try {
    const storedPhases = appStorage.get({ key: StorageKeys.SELECTED_PHASES });
    return Array.isArray(storedPhases) ? storedPhases : [];
  } catch (error) {
    console.warn("Failed to load phases from storage:", error);
    return [];
  }
};

/**
 * Save selected phases of play to local storage
 * @param phases Array of PhaseOfPlay to store
 */
export const savePhasesToStorage = (phases: PhaseOfPlay[]): void => {
  try {
    appStorage.set({
      key: StorageKeys.SELECTED_PHASES,
      data: phases,
      expiry: [30, "days"],
    });
  } catch (error) {
    console.warn("Failed to save phases to storage:", error);
  }
};

/**
 * Clear stored phases from local storage
 */
export const clearStoredPhases = (): void => {
  try {
    appStorage.remove({ key: StorageKeys.SELECTED_PHASES });
  } catch (error) {
    console.warn("Failed to clear phases from storage:", error);
  }
};


